// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2peK2","content":"styles_content__KMn-S"};